const app = {
  state: {
    siteInfo:{},
    isAgentSite:false,//是否为信用网
    language: '',
    languageCode:'',
    languageList: [],
    currencyActive:localStorage.getItem('currencyActive') || '',
    currencyList:[],
    isMobile:false,
    CaptchaVerifiedID: '', // 滑块验证是否成功ID
    ShowCaptcha: false, // 是否显示滑块验证

  },
  mutations: {

    SET_LANG: (state, language) => {
      state.language = language
    },

    SET_LANG_CODE: (state, v) => {
      state.languageCode = v

    },
    SET_SIGN: (state, sign) => {
      state.mustLogin = sign
    },

    SET_LAN_LIST: (state, list) => {
      state.languageList = list
    },
    SET_currencyActive: (state, v) => {
      if(v){
        state.currencyActive = v
      }
    },
    SET_currencyList: (state, v) => {
      state.currencyList = v
    },

    SET_isMobile: (state, v) => {
        state.isMobile = v
    },

    SET_siteInfo:(state, v) => {
        state.siteInfo = v
    },
    SET_isAgentSite:(state, v) => {
        state.isAgentSite = v
    },
    SET_ShowCaptcha: (state, v) => {
      state.ShowCaptcha = v
    },
    SET_CaptchaVerifiedID: (state, v) => {
      state.CaptchaVerifiedID = v
    },

  },
  actions: {
    getAgentDispatch({ commit, dispatch }) {
      let hostname=window.location.hostname;
      let SiteName=process.env.NODE_ENV === 'production' ? hostname: devConfig.domain;//是否为生产环境
      return new Promise((resolve, reject) => {
        getAgentFetch({SiteName:SiteName}).then(res => {
          if (res&&res.success==1){
            commit("SET_firstAgentSite",true)
            if(res.info.IsAgent==1){
              localStorage.setItem("X-Forwarded-Isagent",true);
              commit("SET_AgentSite",true);
            } else{
              localStorage.setItem("X-Forwarded-Isagent",false);
              commit("SET_AgentSite",false);
            }
          }else{
            if(res.info&&res.info.ErrorType=="Maintain"){
              commit('SET_MaintainInfo', res.info);
              commit('SET_Maintain', [])
            }
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/app.js